import { Hidden } from '@material-ui/core';
import React from 'react';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { ListItem } from '../../../../search/search-model';
import { SearchProps } from '../../models/arc-epi-props';
import { InstitutionItem } from '../institutions/institution-model';



interface DioceseItemProps {
	item: ListItem,
	action: () => void,
	settings: SearchProps,
}


export const DioceseItemView = (props: DioceseItemProps) => {

	const casted = props.item as InstitutionItem;
	const buttonClasses = buttonStyles();
	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.dioceseIdLabel}</p>
				</Hidden>
				<p>
					<button className={buttonClasses.linkButton} type='button' onClick={props.action}>
						{casted?.client_number}
					</button>

				</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.dioceseNameLabel}</p>
				</Hidden>
				<p>
					{casted?.diocese}
				</p>
			</div>

		</div>);
};